module.exports = __webpack_public_path__ + "static/media/notification.6ba5597d.mp3";